import $ from 'jquery';
import cart from '@ppcp/cart';
import order from '@ppcp/order';
import {getSetting, getPage} from '@ppcp/utils';
import {registerPaymentMethod} from '@ppcp/payment-methods';
import {CheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import CreditCardGateway from '../gateways/CreditCardGateway';


const settings = getSetting('ppcp_card_data');

// Create credit card gateway
const gateway = new CreditCardGateway({
    id: 'ppcp_card',
    cart,
    settings: settings,
    controller: null
});

// Create checkout controller with gateway
const controller = new CheckoutController({
    id: 'ppcp_card',
    cart,
    order,
    context: new Context(getPage()),
    gateway: gateway,
    settings: settings,
    paymentElementSelector: '.wc-ppcp_card-payment-method__container'
});

// Set controller reference in gateway
controller.initialize();

// Trigger legacy event for backwards compatibility
$(() => {
    $(document.body).trigger('wc-credit-card-form-init');
});

// Register payment method
registerPaymentMethod(gateway);